import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Incident } from '../../models/incident';
import { IncidentComponent } from '../incident/incident';

@Component({
    selector: 'app-active-incidents',
    imports: [IncidentComponent],
    templateUrl: './active-incidents.html',
    styleUrl: './active-incidents.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveIncidentsComponent {
    incidents = input<Incident[]>([]);
}
